module.exports = __webpack_public_path__ + "static/img/14001020.0586338f.png";